export const getFormLabel = (field: string, translation: Record<string, Array<string>>) =>
  (translation?.[field] || []).join('');
